import { ClubStat } from "../data/clubStats";

interface Props {
  stat: ClubStat;
}

export const StatCard = ({ stat }: Props) => {
  const Icon = stat.icon;

  return (
    <article className="flex w-[140px] flex-col items-center gap-6 text-center md:w-[256px] xl:w-[136px]">
      <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-white shadow-[0_3px_6px_rgba(13,13,13,0.09)]">
        <Icon size={28} color="#0D0D0D" />
      </span>
      <div className="flex flex-col gap-1 text-[#0D0D0D]">
        <p className="text-[33px] font-extrabold leading-[1.2]">{stat.value}</p>
        <p className="text-[13px] leading-[1.6] tracking-[0.26px]">{stat.description}</p>
      </div>
    </article>
  );
};
